import axios from "axios";
import * as localforage from "localforage";
import { getDeviceKeyName, setDeviceKeyName } from "./../helpers/commonHelper";

export const getSystemInfoAPI = async deviceId => {
  // const systemInfo = await getDeviceKeyName("systemInfo", deviceId);
  // if (!systemInfo) {
  let response = await axios({
    url: `/api/v2/device/information/system`,
    method: "GET",
    params: {
      device_id: deviceId
    }
  });

  // await localforage.setItem(`systemInfo-${deviceId}`, response.data.system);
  return response.data.system;
  // }

  // return systemInfo;
};

export const getHardwareInfoAPI = async deviceId => {
  // const hardwareInfo = await getDeviceKeyName("hardwareInfo", deviceId);
  // if (!hardwareInfo) {
    let response = await axios({
      url: `/api/v2/device/information/hardware`,
      method: "GET",
      params: {
        device_id: deviceId
      }
    });

    // await setDeviceKeyName("hardwareInfo", deviceId, response.data.hardware);

    return response.data.hardware;
  // }

  // return hardwareInfo;
};

export const getSoftwareInfoAPI = async deviceId => {
  let response = await axios({
    url: `/api/v2/device/information/software`,
    method: "GET",
    params: {
      device_id: deviceId
    }
  });
  return response.data;
};

export const getNetworkInfoAPI = async deviceId => {
  // const networkInfo = await getDeviceKeyName("networkInfo", deviceId);
  // if (!networkInfo) {
    let response = await axios({
      url: `/api/v2/device/information/network`,
      method: "GET",
      params: {
        device_id: deviceId
      }
    });
    // await localforage.setItem(`networkInfo-${deviceId}`, response.data.network);
    return response.data.network;
  // }

  // return networkInfo;
};

export const getComponentsInfoAPI = async device_id => {
  let response = await axios({
    url: `/api/v2/device/information/component`,
    method: "GET",
    params: {
      device_id: device_id
    }
  });
  const componentsInfo = response.data.components;
  return componentsInfo;
};
